import { useCallback } from "react";
import { stringify } from "query-string";
import { ApiRoutes } from "../../../constants/apiRoutes";
import { useApi } from "../../../hooks/useApi";

export default function () {
  const { request } = useApi();

  return {
    fetchCards: useCallback(
      async (filter) => {
        return request({
          method: "GET",
          url: ApiRoutes.GET_PRIVATE_CLASS_CARDS + "?" + stringify(filter),
        });
      },
      [request],
    ),

    fetchCountries: useCallback(() => {
      return request({
        method: "GET",
        url: ApiRoutes.GET_PRIVATE_CLASS_COUNTRIES,
      });
    }, [request]),

    fetchSubjects: useCallback(() => {
      return request({
        method: "GET",
        url: ApiRoutes.GET_PRIVATE_CLASS_SUBJECTS,
      });
    }, [request]),

    fetchTeachingLanguages: useCallback(() => {
      return request({
        method: "GET",
        url: ApiRoutes.GET_PRIVATE_CLASS_TEACHING_LANGUAGES,
      });
    }, [request]),
  };
}
